import * as React from "react";
import {
  Tabs as AtlasTabs,
  TabList as AtlasTabList,
  Tab as AtlasTab,
  TabPanel as AtlasTabPanel,
} from "@wellsky/atlas-ui-react";

import { cn } from "./utils";

function Tabs({
  className,
  value,
  defaultValue,
  onValueChange,
  children,
  ...props
}: Omit<React.ComponentProps<typeof AtlasTabs>, "onChange"> & {
  onValueChange?: (value: string) => void;
}) {
  return (
    <AtlasTabs
      data-slot="tabs"
      className={cn("flex flex-col gap-2", className)}
      value={value}
      defaultValue={defaultValue}
      onChange={onValueChange}
      {...props}
    >
      {children}
    </AtlasTabs>
  );
}

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof AtlasTabList>) {
  return (
    <AtlasTabList
      data-slot="tabs-list"
      className={cn(
        "inline-flex items-center border-b-2 border-border",
        className,
      )}
      {...props}
    />
  );
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof AtlasTab>) {
  return (
    <AtlasTab
      data-slot="tabs-trigger"
      className={cn(
        "relative inline-flex items-center justify-center px-6 py-3 text-foreground whitespace-nowrap transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-muted data-[state=active]:text-primary after:absolute after:bottom-[-2px] after:left-0 after:right-0 after:h-[2px] after:bg-primary after:transition-all data-[state=inactive]:after:opacity-0 data-[state=active]:after:opacity-100",
        className,
      )}
      {...props}
    />
  );
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof AtlasTabPanel>) {
  return (
    <AtlasTabPanel
      data-slot="tabs-content"
      className={cn("flex-1 outline-none", className)}
      {...props}
    />
  );
}

export { Tabs, TabsList, TabsTrigger, TabsContent };
